import React from "react";
import {SearchForm} from "./searchForm"
import WarehouseList from "./warehouseList"
const Warehouse = ():JSX.Element => {
    return (
        <>
        <SearchForm/>
        <WarehouseList/>
        </>
    )
}
export default Warehouse